import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api';
import utils from './utils/utils';
import './plugins/element.js';
import './plugins/custom.js';
import './router/permission';
import UUID from './utils/uuid';
const filters = require('./filter');
const config = require('../config');

Object.keys(filters.default).forEach((key) => {
  Vue.filter(key, filters.default[key]);
});

Vue.prototype.api = api;
Vue.prototype.config = config;
Vue.prototype.utils = utils;
Vue.prototype.isMobile = utils.isMobile();
Vue.prototype.$uuid = UUID;
Vue.prototype.$print = (obj, type) => {
  type = type || 'log';
  const log = JSON.parse(JSON.stringify(obj));
  console[type](log);
};
window.krpjs = {};

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
}).$mount('#app');
